export class HubVisitorPromotionImage {
    public link: String;
    public image: String;
    public isTop: Boolean;
    public isDisabled: Boolean;
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/models/hub/hub.visitor.promotion.image.ts